/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Hourly_HintInputs */



/**
* | output |
* | --- |
* | "Fires once an hour at this minute." |
*
* @param {Agent_Schedule_Hourly_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_hourly_hint = /** @type {((inputs?: Agent_Schedule_Hourly_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Hourly_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird einmal pro Stunde zu dieser Minute ausgelöst.")
	return /** @type {LocalizedString} */ ("Fires once an hour at this minute.")
});